import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import ClientsSection from "@/components/ClientsSection";
import AudienceSection from "@/components/AudienceSection";
import ServicesSection from "@/components/ServicesSection";
import DeliverablesSection from "@/components/DeliverablesSection";
import DeliverSection from "@/components/DeliverSection";
import IndiaSection from "@/components/IndiaSection";
import GlobalSection from "@/components/GlobalSection";
import AboutSection from "@/components/AboutSection";
import FaqSection from "@/components/FaqSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import FloatingHelp from "@/components/FloatingHelp";
import { Seo, SERVICE_JSONLD, FAQ_ITEMS, faqPageJsonLd } from "@/components/Seo";

const Index = () => (
  <div className="min-h-screen bg-background">
    <Seo path="/" jsonLd={[SERVICE_JSONLD, faqPageJsonLd(FAQ_ITEMS)]} />
    <Navbar />
    <main id="main-content" tabIndex={-1}>
      <HeroSection />
      <ClientsSection />
      <AudienceSection />
      <ServicesSection />
      <DeliverablesSection />
      <DeliverSection />
      <IndiaSection />
      <GlobalSection />
      <AboutSection />
      <FaqSection />
      <ContactSection />
    </main>
    <Footer />
    {/* Fixed-position "jump to contact" shortcut. After the footer in the DOM
        so the tab order follows the reading order — header and nav first, then
        content, then the floating controls — instead of this bottom-right
        button taking focus before the logo (WCAG 2.4.3 — NCS-256). Its
        position:fixed keeps it visually bottom-right regardless of DOM order. */}
    <FloatingHelp />
  </div>
);

export default Index;
